<template>
    <div class="sync-status">
        <!-- Loading State -->
        <div v-if="loading" class="sync-loading">
            <img src="@/assets/loading-onboarding.svg" class="loading-icon mb-4" alt="Loading...">
            <h2 class="mb-2">{{ $t('loading_SyncStatus.title') }}</h2>
            <p>{{ $t('loading_SyncStatus.description') }}</p>
        </div>

        <!-- Success State -->
        <div v-else-if="success" class="sync-state">
            <v-row>
                <v-icon color="var(--v-mainGreen-base)" size="48" class="mb-4">fas fa-check-circle</v-icon>
                <v-img
                    :src="platformLogo"
                    contain
                    height="100"
                    class="mb-4"
                    max-width="200"
                ></v-img>
            </v-row>
            <h2 class="mb-2">{{ $t('success_SyncStatus.title') }}</h2>
            <p class="mb-6">{{ $t('success_SyncStatus.description', { trades: totalTrades }) }}</p>
            <v-btn
                color="primary"
                @click="goToTrades"
                class="mb-2"
            >
                {{ $t('success_SyncStatus.viewTrades') }}
            </v-btn>
            <p class="caption">{{ $t('success_SyncStatus.redirect', { seconds: countdown }) }}</p>
        </div>

        <!-- Error State -->
        <div v-else class="sync-state">
            <v-row>
                <v-icon color="#ff5252" size="48" class="mb-4">fas fa-times-circle</v-icon>
                <v-img
                    :src="platformLogo"
                    contain
                    height="100"
                    max-width="200"
                    class="mb-4"
                ></v-img>
            </v-row>
            <h2 class="mb-2">{{ $t('error_SyncStatus.title') }}</h2>
            <p class="mb-6">{{ $t('error_SyncStatus.description') }}</p>
            <v-btn
                outlined
                @click="goBack"
            >
                {{ $t('error_SyncStatus.backButton') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SyncStatus',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        success: {
            type: Boolean,
            default: false
        },
        platformLogo: {
            type: String,
            required: true
        },
        totalTrades: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            countdown: 30,
            redirectTimer: null
        }
    },
    watch: {
        success(newVal) {
            if (newVal) {
                this.startCountdown();
            }
        }
    },
    methods: {
        startCountdown() {
            this.redirectTimer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    this.goToTrades();
                }
            }, 1000);
        },
        goToTrades() {
            clearInterval(this.redirectTimer);
            this.$router.push('/dashboard/', () => {
                this.$router.push('/journal');
            });
        },
        goBack() {
            this.$router.push('/register/integrations');
        }
    },
    beforeDestroy() {
        if (this.redirectTimer) {
            clearInterval(this.redirectTimer);
        }
    }
}
</script>

<style lang="scss" scoped>
.sync-status {
    position: relative;
    width: 100%;
    max-width: 600px;
    min-height: 400px;
    margin: 0;
    padding: 20px;
    display: flex;
    align-items: center;
}

.loading-icon {
    animation: rotate 2s linear infinite;
    margin: 0 auto;
    display: block;
}

.caption{
    font-family: "Avenir", sans-serif;
}

@keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.sync-state, .sync-loading {
    width: 100%;
}

.sync-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    h2, p {
        text-align: center;
        width: 100%;
    }
}

.sync-state {
    text-align: left;

    .v-img {
        margin-left: -12px; // Align with text
    }

    .v-icon {
        margin-left: -6px; // Align with text
    }

    h2, p {
        text-align: left;
    }
}
</style>


